const ResponseToUserStore = user=>{
  const {grupos, diasvencimiento:diasVencimiento , foto_miniatura:fotoPerfil , lastpasswordchange:ultimaModificacionPassword , nombre , username, obrasSociales, fechaVencimiento} = user;
  return {
    grupos
    , diasVencimiento
    , fotoPerfil
    , ultimaModificacionPassword
    , nombre
    , username
    , obrasSociales
    , fechaVencimiento
  }
}

export default {
  ResponseToUserStore
}


// WEBPACK FOOTER //
// ./src/helpers/transformations.js